module.exports = __webpack_public_path__ + "img/eye-catcher-free-tool.46291d88.svg";